<div class="flex-col lg:inline-flex">
  <slot />
</div>
